import { OfferingSearchRequestQuery } from '@lio/api-types';

export const offeringsQueryKey = {
  get: ['offerings'] as const,
  getWithParams: (params: OfferingSearchRequestQuery) => [...offeringsQueryKey.get, params] as const,
  search: ['offerings'] as const,
  searchWithParams: (params: OfferingSearchRequestQuery) => [...offeringsQueryKey.search, params] as const,
};
